import { TModeView } from '../types'

export const getStyle = (viewMode: TModeView) => {
  switch (viewMode) {
    case 'medium-icon':
      return {
        descStyle: {
          height: '2.6em',
          lineClamp: '2',
          lineHeight: '1.3em',
          overflow: 'hidden',
          wordBreak: 'break-word',
          width: '120px',
        },
        deviceStyle: {},
        layoutStyle: { display: 'flex', flexWrap: 'wrap' },
        textStyles: {},
      }

    case 'small-icon':
      return {
        descStyle: {
          height: '3em',
          lineClamp: '2',
          overflow: 'hidden',
          wordBreak: 'break-all',
          width: '160px',
        },
        deviceStyle: { display: 'flex', alignItems: 'center' },
        layoutStyle: { display: 'flex', flexWrap: 'wrap' },
        textStyles: { marginLeft: '0.25em' },
      }

    case 'list':
      return {
        descStyle: {
          height: '1.5em',
          lineClamp: '1',
          overflow: 'hidden',
          wordBreak: 'break-word',
        },
        deviceStyle: { display: 'flex', alignItems: 'center' },
        layoutStyle: { display: 'flex', flexDirection: 'column' },
        textStyles: { marginLeft: '1em' },
      }

    default:
      return {
        descStyle: {
          height: '3em',
          lineClamp: '2',
          overflow: 'hidden',
          wordBreak: 'break-word',
          width: '160px',
        },
        deviceStyle: {},
        layoutStyle: { display: 'flex', flexWrap: 'wrap' },
        textStyles: {},
      }
  }
}
